const HeroTitle = ({ type, cardItem, idx }) => {
  const mapped = {
    title: 'title',
  }

  if (type === 'dynamic') {
    mapped.title = 'listingTitle'
  }

  if (cardItem.ctaLinkItem && cardItem.ctaLinkItem?.length !== 0) {
    // if the editor added a cta in hero mode that link becomes the link in the title.
    return (
      <a href={cardItem.ctaLinkItem[0].link?.url} target={cardItem.ctaLinkItem[0].link?.target ?? '_self'}>
        <h2
          className={`block mt-auto font-bold ${cardItem.useSmallTitle ? 'text-lg' : 'text-2xl'} ${cardItem.titleAlignment ? `text-${cardItem.titleAlignment.toLowerCase()}` : null}`}
        >
          {cardItem[mapped.title]}
        </h2>
      </a>
    )
  } else if (cardItem.listingLink && cardItem.listingLink?.length !== 0) {
    return (
      <a href={cardItem.listingLink}>
        <h2
          className={`block mt-auto font-bold ${cardItem.useSmallTitle ? 'text-lg' : 'text-2xl'} ${cardItem.titleAlignment ? `text-${cardItem.titleAlignment.toLowerCase()}` : null}`}
        >
          {cardItem[mapped.title]}
        </h2>
      </a>
    )
  } else {
    return (
      <h2
        className={`block mt-auto font-bold ${cardItem.useSmallTitle ? 'text-lg' : 'text-2xl'} ${cardItem.titleAlignment ? `text-${cardItem.titleAlignment.toLowerCase()}` : null}`}
      >
        {cardItem[mapped.title]}
      </h2>
    )
  }
}

export default HeroTitle
